var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"athletes"},[_c('carousel-banner',{attrs:{"bannersData":_vm.bannersData}}),_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":_vm.introduce.img_url,"title":_vm.introduce.title,"alt":_vm.introduce.title}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }